import { getTypedValue } from "@coworker/apprestructured/src/shared/helpers/schemaValidator";
import { ViewerFragmentCommonProps } from "../ViewerFragment";
import { getByPath } from "@coworker/apprestructured/src/shared/helpers/object.helper";
import { isLoading } from "@coworker/apprestructured/src/task-management/loading";
import { ItemNoAndTypeWithOrderedDetailsAcknowledge } from "@coworker/apprestructured/src/task-management/types/TaskDetailTypes";
import { ListItem } from "../../../SelectListItem/SelectListItem";
import { ArticlesPrintPTagAndQuantityAcknowledge } from "../../../ArticlesPrintPTagAndQuntityAcknowledge/ArticlesPrintPTagAndQuantityAcknowledge";

export type ArticlesQuantityViewerFragmentConfigProps = {
  title: string;
  subTitle: string;
  pTags?: boolean;
  pieces?: boolean;
  field: string;
  visibility: VisibilityCondition;
};

type ArticlesQuantityViewerFragmentProps = {
  configProps: ArticlesQuantityViewerFragmentConfigProps;
  commonProps: ViewerFragmentCommonProps;
};

interface VisibilityCondition {
  field: string;
  value: any;
  operator: "in";
}

function shouldShowField(
  task: ViewerFragmentCommonProps["task"],
  visibility: VisibilityCondition
): boolean {
  const currentValue = getByPath(task, visibility.field) as ListItem | null;

  if (visibility.operator === "in") {
    return Array.isArray(visibility.value)
      ? visibility.value.includes(currentValue?.value)
      : false;
  }

  return true;
}

export const ArticlesQuantityViewerFragment = ({
  configProps,
  commonProps,
}: ArticlesQuantityViewerFragmentProps) => {
  const { title, subTitle, field, pTags, pieces, visibility } = configProps;
  const { task, onTaskChange } = commonProps;
  const itemsForAcknowledge = getTypedValue<
    ItemNoAndTypeWithOrderedDetailsAcknowledge[]
  >(getByPath(task, field));

  if (!shouldShowField(task, visibility)) {
    return null;
  }

  if (isLoading(itemsForAcknowledge) || itemsForAcknowledge.length === 0) {
    return null;
  }

  return (
    <ArticlesPrintPTagAndQuantityAcknowledge
      title={title}
      subTitle={subTitle}
      pTags={pTags}
      pieces={pieces}
      itemNosAndTypeWithOrderedDetailsAcknowledge={itemsForAcknowledge}
      onAcknowledgeChange={(itemNo, field, approved) => {
        const updatedItems = itemsForAcknowledge.map((item) =>
          item.no === itemNo ? { ...item, [field]: approved } : item
        );
        onTaskChange({ details: { items: updatedItems } });
      }}
      handleConfirm={() => {
        // No action needed in viewer, as this is just for acknowledge and doesn't update any state in the viewer
      }}
    />
  );
};
